import * as React from 'react';
const ThinMessageIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={22}
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <mask id="path-1-inside-1_748_4655" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1248 19.5988C18.5258 19.5988 22.9041 15.2202 22.9041 9.81895C22.9041 4.41767 18.5258 0.0390625 13.1248 0.0390625C7.72386 0.0390625 3.34552 4.41767 3.34552 9.81895C3.34552 11.9284 4.01334 13.8819 5.14909 15.4795L0.921875 21.1593L9.10348 18.7364C10.3301 19.2904 11.6914 19.5988 13.1248 19.5988Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1248 19.5988C18.5258 19.5988 22.9041 15.2202 22.9041 9.81895C22.9041 4.41767 18.5258 0.0390625 13.1248 0.0390625C7.72386 0.0390625 3.34552 4.41767 3.34552 9.81895C3.34552 11.9284 4.01334 13.8819 5.14909 15.4795L0.921875 21.1593L9.10348 18.7364C10.3301 19.2904 11.6914 19.5988 13.1248 19.5988Z"
      fill="white"
    />
    <path
      d="M5.14909 15.4795L6.1759 16.2437L6.73182 15.4967L6.19231 14.7378L5.14909 15.4795ZM0.921875 21.1593L-0.104938 20.3951L-2.3992 23.4777L1.28533 22.3866L0.921875 21.1593ZM9.10348 18.7364L9.6304 17.5699L9.19652 17.3739L8.74003 17.5091L9.10348 18.7364ZM21.6241 9.81895C21.6241 14.5134 17.8188 18.3189 13.1248 18.3189V20.8788C19.2328 20.8788 24.1841 15.9271 24.1841 9.81895H21.6241ZM13.1248 1.31904C17.8188 1.31904 21.6241 5.12451 21.6241 9.81895H24.1841C24.1841 3.71083 19.2328 -1.24092 13.1248 -1.24092V1.31904ZM4.62551 9.81895C4.62551 5.12451 8.43085 1.31904 13.1248 1.31904V-1.24092C7.01687 -1.24092 2.06554 3.71083 2.06554 9.81895H4.62551ZM6.19231 14.7378C5.20551 13.3498 4.62551 11.654 4.62551 9.81895H2.06554C2.06554 12.2028 2.82118 14.414 4.10586 16.2211L6.19231 14.7378ZM1.94869 21.9235L6.1759 16.2437L4.12227 14.7153L-0.104938 20.3951L1.94869 21.9235ZM8.74003 17.5091L0.558419 19.932L1.28533 22.3866L9.46694 19.9637L8.74003 17.5091ZM13.1248 18.3189C11.8767 18.3189 10.6947 18.0506 9.6304 17.5699L8.57656 19.9029C9.96547 20.5303 11.5062 20.8788 13.1248 20.8788V18.3189Z"
      fill="#B3B3B3"
      mask="url(#path-1-inside-1_748_4655)"
    />
  </svg>
);
export default ThinMessageIcon;
